export const PUBLIC_SITE_ORIGIN = "https://forr-health.com";
export const PRODUCT_SITE_ORIGIN = "https://adaptive.physiology.forr-health.com";

const shouldStayOnCurrentOrigin = () => {
  if (typeof window === "undefined") return false;
  return (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname.endsWith(".pages.dev")
  );
};

export const productUrl = (pathname) =>
  shouldStayOnCurrentOrigin() ? pathname : `${PRODUCT_SITE_ORIGIN}${pathname}`;
